import { z } from 'zod';
const adminAddShape = z
    .object({
    userId: z.string().uuid(),
    kind: z.literal('admin'),
    scope: z.enum(['all', 'specific']),
    accessibleOrgIds: z.array(z.string().uuid()).optional(),
})
    .strict()
    .refine((data) => data.scope !== 'specific' ||
    (Array.isArray(data.accessibleOrgIds) && data.accessibleOrgIds.length > 0), { message: 'specific_scope_requires_at_least_one_org' });
const memberAddShape = z
    .object({
    userId: z.string().uuid(),
    kind: z.literal('member'),
    roleId: z.string().uuid(),
})
    .strict();
// Zod 3: discriminatedUnion requires ZodObject discriminants. Once a
// `.refine()` is applied to a ZodObject the result is a ZodEffects, which
// discriminatedUnion rejects. Match the pattern used by
// updateGroupMemberSchema and use a plain z.union here so the admin-shape
// refinement (specific scope ⇒ non-empty orgs) remains discriminator-free
// at the validator layer. Branch selection by `kind` happens via Zod's
// shape-matching on `userId+kind+...` (admin has scope, member has roleId).
export const addGroupMemberSchema = z.union([adminAddShape, memberAddShape]);
//# sourceMappingURL=add-group-member.schema.js.map